import type { IVideoResultItem, IVideoTag } from '~/types/video'

import { listUserVideo, listVideo } from '~/api/videos'
import { VIDEO_CATEGORIES } from '~/types/video'

export const queryConfig = {
  [VIDEO_CATEGORIES.CONFERENCES]: {
    apiFn: (search?: string): Promise<IPaginatedResponse<IVideoResultItem>> =>
      listVideo({ category: VIDEO_CATEGORIES.CONFERENCES, q: search }),
    title: 'Conferences',
  },
  [VIDEO_CATEGORIES.TUTORIALS]: {
    apiFn: (search?: string): Promise<IPaginatedResponse<IVideoResultItem>> =>
      listVideo({ category: VIDEO_CATEGORIES.TUTORIALS, q: search }),
    title: 'Intranet tutorials',
  },
  [VIDEO_CATEGORIES.OTHER]: {
    apiFn: (search?: string): Promise<IPaginatedResponse<IVideoResultItem>> =>
      listVideo({ category: VIDEO_CATEGORIES.OTHER, q: search }),
    title: 'Other',
  },
  [VIDEO_CATEGORIES.LATEST]: {
    apiFn: (search?: string): Promise<IPaginatedResponse<IVideoResultItem>> => listVideo({ q: search }),
    title: 'Latest videos',
  },
  [VIDEO_CATEGORIES.MY_LIST]: {
    apiFn: (search?: string): Promise<IPaginatedResponse<IVideoResultItem>> => listUserVideo({ q: search }),
    title: 'My list',
  },
  [VIDEO_CATEGORIES.PEOPLE]: {
    apiFn: (search?: string): Promise<IPaginatedResponse<IVideoResultItem>> =>
      listVideo({ category: VIDEO_CATEGORIES.PEOPLE, q: search }),
    title: 'People',
  },
  [VIDEO_CATEGORIES.MONTHLY]: {
    apiFn: (search?: string): Promise<IPaginatedResponse<IVideoResultItem>> =>
      listVideo({ category: VIDEO_CATEGORIES.MONTHLY, q: search }),
    title: 'Monthly',
  },
}

export const parseDuration = (duration: number): string => {
  const parseMinutesOrSecondes = (number: number): string => {
    return (number < 10 ? '0' : '') + number.toString()
  }

  let parsedDuration = ''
  const dateDuration = new Date(duration * 1000)
  const hours = dateDuration.getUTCHours()

  if (hours !== 0) {
    parsedDuration = hours.toString() + ':'
  }

  const minutes = dateDuration.getUTCMinutes()

  if (hours !== 0) {
    parsedDuration += parseMinutesOrSecondes(minutes) + ':'
  } else {
    parsedDuration += minutes.toString() + ':'
  }

  const secondes = dateDuration.getUTCSeconds()
  parsedDuration += parseMinutesOrSecondes(secondes)

  return parsedDuration
}

export const filter = (title: string, tags: IVideoTag[], search: string): boolean => {
  const searchToLower = search.toLowerCase()
  return (
    title.toLowerCase().includes(searchToLower) ||
    tags.some(({ name }) => name.toLocaleLowerCase().includes(searchToLower))
  )
}
